import React from 'react';
import { Hero } from '../components/Hero';
import { CostComparisonSection } from '../components/CostComparisonSection';
import { SimpleExperienceSection } from '../components/SimpleExperienceSection';
import { AboutSection } from '../components/AboutSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { ArrowRightIcon, CheckCircleIcon, TrendingUpIcon, MapPinIcon, MessageSquareIcon, ClockIcon, CalendarIcon, ShieldCheckIcon, AwardIcon, UsersIcon, StarIcon, DollarSignIcon, SparklesIcon } from 'lucide-react';
export function Home() {
  return <div data-id="element-946">
      <Hero data-id="element-947" />
      {/* Trust Bar */}
      <section className="py-8 bg-slate-50 border-y border-slate-200" data-id="element-948">
        <div className="container mx-auto px-4" data-id="element-949">
          <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16" data-id="element-950">
            <div className="flex items-center gap-3" data-id="element-951">
              <div className="bg-blue-600 p-2 rounded-lg" data-id="element-952">
                <ShieldCheckIcon className="text-white" size={20} data-id="element-953" />
              </div>
              <div data-id="element-954">
                <p className="font-bold text-slate-900" data-id="element-955">EU Certified</p>
                <p className="text-sm text-slate-600" data-id="element-956">Partner Clinics</p>
              </div>
            </div>
            <div className="flex items-center gap-3" data-id="element-957">
              <div className="bg-blue-600 p-2 rounded-lg" data-id="element-958">
                <UsersIcon className="text-white" size={20} data-id="element-959" />
              </div>
              <div data-id="element-960">
                <p className="font-bold text-slate-900" data-id="element-961">200+ Families</p>
                <p className="text-sm text-slate-600" data-id="element-962">Helped</p>
              </div>
            </div>
            <div className="flex items-center gap-3" data-id="element-963">
              <div className="flex" data-id="element-964">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="text-amber-400 fill-current" size={16} data-id="element-965" />)}
              </div>
              <div data-id="element-966">
                <p className="font-bold text-slate-900" data-id="element-967">4.9/5 Rating</p>
                <p className="text-sm text-slate-600" data-id="element-968">From 180+ Reviews</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <CostComparisonSection data-id="element-969" />
      <SimpleExperienceSection data-id="element-970" />
      {/* Professional Support Section */}
      <section className="py-20 bg-gradient-to-br from-blue-600 to-cyan-600" data-id="element-971">
        <div className="container mx-auto px-4" data-id="element-972">
          <div className="max-w-5xl mx-auto" data-id="element-973">
            <div className="text-center mb-12" data-id="element-974">
              <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-975">
                Expert Coordination for Your Fertility Journey
              </h2>
              <p className="text-blue-50 text-lg md:text-xl max-w-3xl mx-auto leading-relaxed" data-id="element-976">
                Our experienced coordinators provide comprehensive support
                throughout your treatment journey, handling all legal paperwork,
                logistics, and coordination from initial consultation through
                post-treatment care. We manage the details so you can focus on
                what matters most.
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12" data-id="element-977">
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20" data-id="element-978">
                <div className="bg-white/20 p-3 rounded-xl inline-block mb-4" data-id="element-979">
                  <ShieldCheckIcon className="text-white" size={24} data-id="element-980" />
                </div>
                <h3 className="text-white font-bold text-lg mb-2" data-id="element-981">
                  Complete Legal Support
                </h3>
                <p className="text-blue-100 text-sm" data-id="element-982">
                  We handle all legal documentation, paperwork, and compliance
                  requirements for cross-border treatment
                </p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20" data-id="element-983">
                <div className="bg-white/20 p-3 rounded-xl inline-block mb-4" data-id="element-984">
                  <MessageSquareIcon className="text-white" size={24} data-id="element-985" />
                </div>
                <h3 className="text-white font-bold text-lg mb-2" data-id="element-986">
                  Dedicated Support
                </h3>
                <p className="text-blue-100 text-sm" data-id="element-987">
                  Your personal coordinator guides you through every step with
                  24/7 availability
                </p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20" data-id="element-988">
                <div className="bg-white/20 p-3 rounded-xl inline-block mb-4" data-id="element-989">
                  <CalendarIcon className="text-white" size={24} data-id="element-990" />
                </div>
                <h3 className="text-white font-bold text-lg mb-2" data-id="element-991">
                  Transparent Process
                </h3>
                <p className="text-blue-100 text-sm" data-id="element-992">
                  Clear timelines, fixed pricing, and no hidden fees throughout
                  your journey
                </p>
              </div>
            </div>
            <div className="text-center" data-id="element-993">
              <a href="/contact" className="inline-block bg-white text-blue-600 px-10 py-5 rounded-full hover:bg-blue-50 transition-all duration-300 shadow-2xl font-bold text-lg" data-id="element-994">
                Schedule Your Free Consultation
              </a>
              <p className="text-blue-100 text-sm mt-4" data-id="element-995">
                ✓ No obligation • ✓ Confidential • ✓ Expert guidance
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Partner Clinics Preview */}
      <section className="py-20 bg-white" data-id="element-996">
        <div className="container mx-auto px-4" data-id="element-997">
          <div className="text-center mb-12" data-id="element-998">
            <div className="inline-block bg-blue-50 rounded-full px-4 py-2 mb-4" data-id="element-999">
              <span className="text-blue-700 font-semibold text-sm tracking-wide uppercase" data-id="element-1000">
                Our Network
              </span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4" data-id="element-1001">
              Premier <span className="text-blue-600" data-id="element-1002">Partner Clinics</span>
            </h2>
            <p className="text-slate-600 max-w-2xl mx-auto text-lg" data-id="element-1003">
              We work with top-rated fertility clinics across Europe
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto mb-12" data-id="element-1004">
            <div className="bg-gradient-to-br from-slate-50 to-white border border-slate-100 rounded-3xl p-8 hover:shadow-xl transition-all duration-300" data-id="element-1005">
              <div className="bg-gradient-to-br from-blue-600 to-blue-700 p-4 rounded-2xl inline-block mb-6" data-id="element-1006">
                <MapPinIcon className="text-white" size={28} data-id="element-1007" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-1008">
                Czech Republic
              </h3>
              <p className="text-slate-600" data-id="element-1009">
                State-of-the-art facilities with 65% success rates
              </p>
            </div>
            <div className="bg-gradient-to-br from-slate-50 to-white border border-slate-100 rounded-3xl p-8 hover:shadow-xl transition-all duration-300" data-id="element-1010">
              <div className="bg-gradient-to-br from-cyan-600 to-cyan-700 p-4 rounded-2xl inline-block mb-6" data-id="element-1011">
                <MapPinIcon className="text-white" size={28} data-id="element-1012" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-1013">Spain</h3>
              <p className="text-slate-600" data-id="element-1014">
                Advanced technology with experienced specialists
              </p>
            </div>
            <div className="bg-gradient-to-br from-slate-50 to-white border border-slate-100 rounded-3xl p-8 hover:shadow-xl transition-all duration-300" data-id="element-1015">
              <div className="bg-gradient-to-br from-blue-500 to-blue-600 p-4 rounded-2xl inline-block mb-6" data-id="element-1016">
                <MapPinIcon className="text-white" size={28} data-id="element-1017" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-1018">Poland</h3>
              <p className="text-slate-600" data-id="element-1019">
                Affordable excellence with proven results
              </p>
            </div>
          </div>
          {/* Common Features for All Clinics */}
          <div className="max-w-4xl mx-auto mb-12" data-id="element-1020">
            <div className="bg-gradient-to-br from-blue-50 to-cyan-50 border border-blue-100 rounded-3xl p-8" data-id="element-1021">
              <h3 className="text-center text-xl font-bold text-slate-900 mb-6" data-id="element-1022">
                All Partner Clinics Include
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1023">
                <div className="flex items-center gap-3" data-id="element-1024">
                  <div className="bg-blue-600 p-3 rounded-xl flex-shrink-0" data-id="element-1025">
                    <MessageSquareIcon className="text-white" size={20} data-id="element-1026" />
                  </div>
                  <div data-id="element-1027">
                    <p className="font-semibold text-slate-900" data-id="element-1028">
                      English-Speaking Staff
                    </p>
                    <p className="text-sm text-slate-600" data-id="element-1029">
                      Full language support
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-3" data-id="element-1030">
                  <div className="bg-cyan-600 p-3 rounded-xl flex-shrink-0" data-id="element-1031">
                    <ClockIcon className="text-white" size={20} data-id="element-1032" />
                  </div>
                  <div data-id="element-1033">
                    <p className="font-semibold text-slate-900" data-id="element-1034">24/7 Support</p>
                    <p className="text-sm text-slate-600" data-id="element-1035">Always available</p>
                  </div>
                </div>
                <div className="flex items-center gap-3" data-id="element-1036">
                  <div className="bg-blue-500 p-3 rounded-xl flex-shrink-0" data-id="element-1037">
                    <CalendarIcon className="text-white" size={20} data-id="element-1038" />
                  </div>
                  <div data-id="element-1039">
                    <p className="font-semibold text-slate-900" data-id="element-1040">
                      Flexible Scheduling
                    </p>
                    <p className="text-sm text-slate-600" data-id="element-1041">
                      Works with your timeline
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="text-center" data-id="element-1042">
            <a href="/clinics" className="inline-flex items-center gap-2 bg-blue-600 text-white px-8 py-4 rounded-full hover:bg-blue-700 transition-all duration-300 shadow-lg hover:shadow-blue-600/30 font-medium" data-id="element-1043">
              View All Partner Clinics
              <ArrowRightIcon size={20} data-id="element-1044" />
            </a>
          </div>
        </div>
      </section>
      {/* Success Rates */}
      <section className="py-20 bg-gradient-to-b from-slate-50 to-white" data-id="element-1045">
        <div className="container mx-auto px-4" data-id="element-1046">
          <div className="max-w-5xl mx-auto" data-id="element-1047">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-1048">
              <div data-id="element-1049">
                <div className="inline-block bg-blue-50 rounded-full px-4 py-2 mb-4" data-id="element-1050">
                  <span className="text-blue-700 font-semibold text-sm tracking-wide uppercase" data-id="element-1051">
                    Success Rates
                  </span>
                </div>
                <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6" data-id="element-1052">
                  Proven <span className="text-blue-600" data-id="element-1053">Results</span>
                </h2>
                <p className="text-slate-600 text-lg mb-8" data-id="element-1054">
                  Our partner clinics consistently achieve success rates above
                  the European average, with personalized treatment plans that
                  maximize your chances of success.
                </p>
                <a href="/clinics" className="inline-flex items-center gap-2 text-blue-600 font-semibold hover:text-blue-700 transition-colors" data-id="element-1055">
                  See Detailed Statistics
                  <ArrowRightIcon size={20} data-id="element-1056" />
                </a>
              </div>
              <div className="grid grid-cols-2 gap-6" data-id="element-1057">
                <div className="bg-white border border-slate-100 rounded-3xl p-8 text-center hover:shadow-xl transition-all" data-id="element-1058">
                  <div className="bg-gradient-to-br from-blue-600 to-blue-700 p-3 rounded-2xl inline-block mb-4" data-id="element-1059">
                    <TrendingUpIcon className="text-white" size={24} data-id="element-1060" />
                  </div>
                  <div className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-br from-blue-600 to-cyan-600 mb-2" data-id="element-1061">
                    65%
                  </div>
                  <div className="text-slate-600 font-medium" data-id="element-1062">
                    Average Success Rate
                  </div>
                </div>
                <div className="bg-white border border-slate-100 rounded-3xl p-8 text-center hover:shadow-xl transition-all" data-id="element-1063">
                  <div className="bg-gradient-to-br from-cyan-600 to-cyan-700 p-3 rounded-2xl inline-block mb-4" data-id="element-1064">
                    <CheckCircleIcon className="text-white" size={24} data-id="element-1065" />
                  </div>
                  <div className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-br from-cyan-600 to-blue-600 mb-2" data-id="element-1066">
                    250+
                  </div>
                  <div className="text-slate-600 font-medium" data-id="element-1067">
                    Coordinated Trips
                  </div>
                </div>
                <div className="bg-white border border-slate-100 rounded-3xl p-8 text-center hover:shadow-xl transition-all" data-id="element-1068">
                  <div className="bg-gradient-to-br from-blue-500 to-blue-600 p-3 rounded-2xl inline-block mb-4" data-id="element-1069">
                    <TrendingUpIcon className="text-white" size={24} data-id="element-1070" />
                  </div>
                  <div className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-br from-blue-600 to-cyan-600 mb-2" data-id="element-1071">
                    85%
                  </div>
                  <div className="text-slate-600 font-medium" data-id="element-1072">
                    Patient Satisfaction
                  </div>
                </div>
                <div className="bg-white border border-slate-100 rounded-3xl p-8 text-center hover:shadow-xl transition-all" data-id="element-1073">
                  <div className="bg-gradient-to-br from-cyan-500 to-cyan-600 p-3 rounded-2xl inline-block mb-4" data-id="element-1074">
                    <CheckCircleIcon className="text-white" size={24} data-id="element-1075" />
                  </div>
                  <div className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-br from-cyan-600 to-blue-600 mb-2" data-id="element-1076">
                    4+
                  </div>
                  <div className="text-slate-600 font-medium" data-id="element-1077">
                    Years Experience
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Testimonials */}
      <TestimonialsSection data-id="element-1078" />
      {/* Social Proof Section */}
      <section className="py-16 bg-white" data-id="element-1079">
        <div className="container mx-auto px-4" data-id="element-1080">
          <div className="max-w-4xl mx-auto" data-id="element-1081">
            <div className="bg-gradient-to-br from-blue-50 to-cyan-50 border-2 border-blue-200 rounded-3xl p-8 md:p-12" data-id="element-1082">
              <div className="text-center mb-8" data-id="element-1083">
                <h3 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-1084">
                  Why Families Choose Nura
                </h3>
                <p className="text-slate-600 text-lg" data-id="element-1085">
                  Join hundreds of families who trusted us with their journey
                </p>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1086">
                <div className="text-center" data-id="element-1087">
                  <div className="text-5xl font-bold text-blue-600 mb-2" data-id="element-1088">
                    100%
                  </div>
                  <p className="text-slate-900 font-semibold mb-1" data-id="element-1089">
                    Transparent Pricing
                  </p>
                  <p className="text-slate-600 text-sm" data-id="element-1090">
                    No hidden fees or surprises
                  </p>
                </div>
                <div className="text-center" data-id="element-1091">
                  <div className="text-5xl font-bold text-blue-600 mb-2" data-id="element-1092">
                    24/7
                  </div>
                  <p className="text-slate-900 font-semibold mb-1" data-id="element-1093">
                    Dedicated Support
                  </p>
                  <p className="text-slate-600 text-sm" data-id="element-1094">
                    Your coordinator available anytime
                  </p>
                </div>
                <div className="text-center" data-id="element-1095">
                  <div className="text-5xl font-bold text-blue-600 mb-2" data-id="element-1096">
                    3-6
                  </div>
                  <p className="text-slate-900 font-semibold mb-1" data-id="element-1097">Days Away</p>
                  <p className="text-slate-600 text-sm" data-id="element-1098">
                    Minimal time off work required
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Quick Links Section */}
      <section className="py-20 bg-gradient-to-b from-white to-slate-50" data-id="element-1099">
        <div className="container mx-auto px-4" data-id="element-1100">
          <div className="text-center mb-12" data-id="element-1101">
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4" data-id="element-1102">
              Explore Our <span className="text-blue-600" data-id="element-1103">Services</span>
            </h2>
            <p className="text-slate-600 max-w-2xl mx-auto text-lg" data-id="element-1104">
              Learn more about our treatment packages and comprehensive support
              services
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-1105">
            <a href="/packages" className="group bg-white border border-slate-200 rounded-3xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-1" data-id="element-1106">
              <h3 className="text-2xl font-bold text-slate-900 mb-3" data-id="element-1107">
                Treatment Packages
              </h3>
              <p className="text-slate-600 mb-4" data-id="element-1108">
                View our comprehensive coordination packages with transparent
                pricing
              </p>
              <div className="flex items-center text-blue-600 font-semibold" data-id="element-1109">
                View Packages
                <ArrowRightIcon className="ml-2 group-hover:translate-x-1 transition-transform" size={20} data-id="element-1110" />
              </div>
            </a>
            <a href="/treatments" className="group bg-white border border-slate-200 rounded-3xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-1" data-id="element-1111">
              <h3 className="text-2xl font-bold text-slate-900 mb-3" data-id="element-1112">
                Treatment Options
              </h3>
              <p className="text-slate-600 mb-4" data-id="element-1113">
                Explore personalized IVF treatments tailored to your needs
              </p>
              <div className="flex items-center text-blue-600 font-semibold" data-id="element-1114">
                Explore Treatments
                <ArrowRightIcon className="ml-2 group-hover:translate-x-1 transition-transform" size={20} data-id="element-1115" />
              </div>
            </a>
            <a href="/about" className="group bg-white border border-slate-200 rounded-3xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-1" data-id="element-1116">
              <h3 className="text-2xl font-bold text-slate-900 mb-3" data-id="element-1117">
                Our Services
              </h3>
              <p className="text-slate-600 mb-4" data-id="element-1118">
                Discover our complete coordination and support services
              </p>
              <div className="flex items-center text-blue-600 font-semibold" data-id="element-1119">
                Learn More
                <ArrowRightIcon className="ml-2 group-hover:translate-x-1 transition-transform" size={20} data-id="element-1120" />
              </div>
            </a>
          </div>
        </div>
      </section>
      {/* Final CTA */}
      <section className="py-20 bg-gradient-to-br from-blue-600 to-cyan-600" data-id="element-1121">
        <div className="container mx-auto px-4" data-id="element-1122">
          <div className="max-w-4xl mx-auto text-center" data-id="element-1123">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-1124">
              Ready to Start Your Journey?
            </h2>
            <p className="text-blue-50 text-lg mb-8 max-w-2xl mx-auto" data-id="element-1125">
              Schedule a free consultation with our fertility coordinators to
              discuss your options and create a personalized treatment plan.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8" data-id="element-1126">
              <a href="/contact" className="bg-white text-blue-600 px-10 py-5 rounded-full hover:bg-blue-50 transition-all duration-300 shadow-lg font-bold text-lg" data-id="element-1127">
                Free Consultation
              </a>
              <a href="/packages" className="bg-transparent border-2 border-white text-white px-10 py-5 rounded-full hover:bg-white/10 transition-all duration-300 font-bold text-lg" data-id="element-1128">
                View Packages
              </a>
            </div>
            <div className="flex flex-wrap justify-center gap-6 text-blue-100" data-id="element-1129">
              <div className="flex items-center gap-2" data-id="element-1130">
                <CheckCircleIcon size={20} data-id="element-1131" />
                <span data-id="element-1132">No Obligation</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-1133">
                <CheckCircleIcon size={20} data-id="element-1134" />
                <span data-id="element-1135">100% Confidential</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-1136">
                <CheckCircleIcon size={20} data-id="element-1137" />
                <span data-id="element-1138">Expert Guidance</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
}